import AuthenticationService from "@app/authentication/authenticationService";
import { User } from "oidc-client-ts";

/**
 * A simple utility function to create a new, hidden link on the fly so that the user never sees their own access token
 * The access token is necessary because the UI and API are at different addresses and the auth cookie isn't sent cross-origin, resulting in a 403
 * @param downloadLink The API link to be used for the download
 * @param loadedUser In case the using component has multiple download links and we want to avoid fetching the user info every time
 */
export const authenticatedDownload = (tokenlessDownloadLink: string, loadedUser?: User, query: URLSearchParams = new URLSearchParams()): void => {
  const user = loadedUser || AuthenticationService.getInstance().getUser();
  let queryString = "";
  for (const q of query) {
    queryString += `&${q[0]}=${q[1]}`
  }
  const link = `${tokenlessDownloadLink}?access_token=${user.access_token}${queryString}`;
  const downloadAnchor = document.createElement("a");
  downloadAnchor.href = link;
  downloadAnchor.style.position = "absolute";
  downloadAnchor.style.visibility = "hidden";
  document.body.appendChild(downloadAnchor);
  const clickEvent = new MouseEvent("click");
  downloadAnchor.dispatchEvent(clickEvent);
  document.body.removeChild(downloadAnchor);
}

export const authenticatedDownloadAsync = async (tokenlessDownloadLink: string, loadedUser?: User, fileName?: string, query: URLSearchParams = new URLSearchParams()): Promise<void> => {
  const user = loadedUser || AuthenticationService.getInstance().getUser();
  let queryString = "";
  for (const q of query) {
    queryString += `&${q[0]}=${q[1]}`
  }
  const link = `${tokenlessDownloadLink}?access_token=${user.access_token}${queryString}`;
  const image = await fetch(link);
  const imageBlob = await image.blob();
  const imageURL = URL.createObjectURL(imageBlob);

  const anchor = document.createElement("a");
  anchor.href = imageURL;
  if (!!fileName && fileName.trim().length > 0)
    anchor.download = fileName;

  document.body.appendChild(anchor);
  anchor.click();
  document.body.removeChild(anchor);

  URL.revokeObjectURL(imageURL);
}